import { computed } from '@ember/object';

export default function (arr, key, val) {
  return computed(`${arr}.@each.${key}`, val, function () {
    return (this.get(arr) || []).findBy(key, this.get(val));
  });
}
